import { render, staticRenderFns } from "./acenteBasvur.vue?vue&type=template&id=fc7f7ff2"
import script from "./acenteBasvur.vue?vue&type=script&lang=js"
export * from "./acenteBasvur.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports